export default __webpack_public_path__ + "static/media/Poppins-ExtraLight.e0b46f52.svg";